document.addEventListener('turbo:load', function() {
  const twoMinuteDrillPage = $('#two-minute-drill-top-form');

  twoMinuteDrillPage.on('click', '.add-addon-data-button', function () {
    const cardParent = $(this).closest('.addon-data-card');
    const fieldsParent = cardParent.find('.addon-data-fields')
    const lastChild = fieldsParent.children().last();
    if (lastChild.hasClass('d-none')) {
      lastChild.removeClass('d-none');
      cardParent.find('.addon-data-none').addClass('d-none');
    } else {
      const clone = lastChild.clone();
      clone.appendTo(fieldsParent);
    }
    cardParent.find('.save-addon-data-button').removeClass('d-none');
    cardParent.find('.addon-data-none').addClass('d-none');
  });

  twoMinuteDrillPage.on('click', '.delete-addon-data-button', function() {
    if (!confirm('Are you sure you want to delete this?')) return;

    const cardParent = $(this).closest('.addon-data-card');
    const hsBrandId = cardParent.attr('hs_brand_id');
    const addonDataType = cardParent.attr('addon_data_type');
    const addonDataId = $(this).attr('addon_data_id')
    const tr = $(this).closest('tr');
    const table = $(this).closest('table');
    let data = {
      addon_data_type: addonDataType,
      addon_data_id: addonDataId
    };
    $.ajax({
      url: `/brands/${hsBrandId}/delete_addon_data`,
      method: 'delete',
      data: data
    }).done(function(data) {
      if (data['success']) tr.remove();
      if (!table.find('tr').length) cardParent.find('.addon-data-none').removeClass('d-none');
    }).fail(function(response) {
      let data = response.responseJSON;
      alert(`There was an issue removing this data. Let us know if this issue persists. Type: ${addonDataType}, ID: ${addonDataId}\n\nError: ${data['error']}`)
    });
  });

  twoMinuteDrillPage.on('click', '.save-addon-data-button', function() {
    const cardParent = $(this).closest('.addon-data-card');
    const hsBrandId = cardParent.attr('hs_brand_id');
    let data = {}
    cardParent.find('.addon-data-fields').find('input, select, textarea').each(function() {
      const name = $(this).attr('name').replace('[]', '');
      data[name] ||= [];
      data[name].push($(this).val());
    });
    $.post(`/brands/${hsBrandId}/update_addon_data`, {
      addon_data_type: cardParent.attr('addon_data_type'),
      allowed_to_edit: cardParent.attr('allowed_to_edit'),
      data: data
    }).done(function(html) {
      cardParent.replaceWith(html);
    }).fail(function(response) {
      const data = response.responseJSON;
      console.log(data);
      setTimeout(function() {
        // Wait a small amount of time before showing alert. This alert sometimes glitches and doesn't show up properly for some reason if shown immediately.
        alert(`There was an issue saving this data. Let us know if this issue persists.\n\nError: ${data['error']}`);
      }, 100);
    });
  });

  // Stop enter key from submitting the entire two minute drill form on these addon data fields.
  twoMinuteDrillPage.on('keydown', '.addon-data-fields', function (e) {
    if (e.keyCode === 13) e.preventDefault();
  });
});